import React from 'react'
import { Text, View } from 'react-native'
import theme from '../../../theme'
import { FormFieldsModel, ModelAnswerFromProps } from './models/StoreDetailModel'
import { InputPhotoField } from './FieldItems/InputPhotoField'
import { InputCommentField } from './FieldItems/InputCommentField'
import { InputNumberPriceField } from './FieldItems/InputNumberPriceField'
import { InputDateField } from './FieldItems/InputDateField'
import { PonderateNumberField } from './FieldItems/PonderateNumberField'
import { ValidationParentContext } from './FieldItems/useValidationAlerts'
import { SiNoNaField } from './FormItems/SiNoNaItem'
import {
    DropdownField,
    DropdownMultipleSelectField,
} from './FieldItems/DropdownField'
import { usePonderateGroup } from './hooks/usePonderateGroup'
import { useFieldsVisibility } from './hooks/useFieldsVisibility'
import { fieldCardStyle } from './executionCardStyles'

interface FieldsViewProps {
    fields: FormFieldsModel[]
    form_id: string
    schedule_id: string
    store_id: string
    answerProp: ModelAnswerFromProps
    answers?: ModelAnswerFromProps[]
    closeBottomSheet: (l) => void
    checkComplete: (option?: ModelAnswerFromProps) => void
    keyboardHiddenState: boolean
    onFocus: (id: string) => void
    activeInputId: string
    saveItemSteps?: (option?: ModelAnswerFromProps) => void
    onSubInputMeasure?: (id: string, screenY: number, inputH: number) => void
    parentContext?: ValidationParentContext
    // Ids incompletos que vienen desde ExecutionView (ver
    // getMissingRequiredFieldIds): si el _id sintético de un field está acá,
    // ese field required quedó sin responder y se marca el error debajo suyo.
    incompleteIds?: Set<string>
}

export const FieldsView = ({
    fields,
    form_id,
    schedule_id,
    store_id,
    answerProp,
    answers,
    closeBottomSheet,
    checkComplete,
    keyboardHiddenState,
    onFocus,
    activeInputId,
    saveItemSteps,
    onSubInputMeasure,
    parentContext,
    incompleteIds,
}: FieldsViewProps) => {
    // console.log('FieldsView ~ fields:', fields)
    // console.log('FieldsView ~ answerProp:', answerProp)

    const {
        getFieldSavedText,
        onFieldComplete: onPonderateFieldComplete,
        resultText: ponderateResultText,
    } = usePonderateGroup({
        fields,
        answers,
        answerProp,
        form_id,
        schedule_id,
        store_id,
        checkComplete,
    })

    const { isFieldHidden, onFieldAnswered } = useFieldsVisibility({
        fields,
        answers,
    })

    return (
        <View>
            {fields.map((field, index) => {
                if (isFieldHidden(field)) {
                    return null
                }
                return (
                    <View
                        key={field.label + index}
                        style={[fieldCardStyle, { overflow: 'hidden' }]}
                    >
                        {/* <Text>{field.type?.type}</Text> */}
                        {(() => {
                            switch (field.type?.type) {
                                case 4:
                                    return (
                                        <View
                                            style={{
                                                paddingHorizontal: 0,
                                                flex: 1,
                                                overflow: 'hidden',
                                            }}
                                        >
                                            <InputPhotoField
                                                item={field}
                                                hasCamera={true}
                                                hasGalery={true}
                                                form_id={form_id}
                                                schedule_id={schedule_id}
                                                store_id={store_id}
                                                answerProp={answerProp}
                                                answers={answers}
                                                key={field.label + index}
                                                checkComplete={checkComplete}
                                                saveItemSteps={saveItemSteps}
                                            />
                                        </View>
                                    )
                                case 5:
                                    return (
                                        <InputCommentField
                                            item={field}
                                            form_id={form_id}
                                            schedule_id={schedule_id}
                                            store_id={store_id}
                                            answerProp={answerProp}
                                            key={field.label + index}
                                            closeBottomSheet={closeBottomSheet}
                                            checkComplete={checkComplete}
                                            keyboardHiddenState={keyboardHiddenState}
                                            onFocus={onFocus}
                                            activeInputId={activeInputId}
                                            saveItemSteps={saveItemSteps}
                                            onSubInputMeasure={onSubInputMeasure}
                                            initialValue={getFieldSavedText(field)}
                                        />
                                    )
                                case 9:
                                case 15:
                                    return (
                                        <InputNumberPriceField
                                            item={field}
                                            form_id={form_id}
                                            schedule_id={schedule_id}
                                            store_id={store_id}
                                            answerProp={answerProp}
                                            key={field.label + index}
                                            closeBottomSheet={closeBottomSheet}
                                            checkComplete={onPonderateFieldComplete(
                                                field,
                                            )}
                                            keyboardHiddenState={keyboardHiddenState}
                                            onFocus={onFocus}
                                            activeInputId={activeInputId}
                                            isPrice={field.type?.type === 15}
                                            onSubInputMeasure={onSubInputMeasure}
                                            disabled={
                                                field.ponderate_config?.role ===
                                                'result'
                                            }
                                            initialValue={getFieldSavedText(field)}
                                            computedValue={
                                                field.ponderate_config?.role ===
                                                'result'
                                                    ? (ponderateResultText ??
                                                      getFieldSavedText(field))
                                                    : undefined
                                            }
                                            parentContext={parentContext}
                                        />
                                    )

                                case 10:
                                    return (
                                        <DropdownField
                                            item={field}
                                            form_id={form_id}
                                            schedule_id={schedule_id}
                                            store_id={store_id}
                                            answerProp={answerProp}
                                            answers={answers}
                                            key={field.label + index}
                                            checkComplete={checkComplete}
                                            saveItemSteps={saveItemSteps}
                                            onAnswerChange={onFieldAnswered(field)}
                                        />
                                    ) //Dropdown
                                case 11:
                                    return (
                                        <DropdownMultipleSelectField
                                            item={field}
                                            form_id={form_id}
                                            schedule_id={schedule_id}
                                            store_id={store_id}
                                            answerProp={answerProp}
                                            answers={answers}
                                            key={field.label + index}
                                            checkComplete={checkComplete}
                                            saveItemSteps={saveItemSteps}
                                            onAnswerChange={onFieldAnswered(field)}
                                        />
                                    ) //DropdownMultipleSelect
                                case 32:
                                    return (
                                        <InputPhotoField
                                            item={field}
                                            hasCamera={true}
                                            hasGalery={false}
                                            form_id={form_id}
                                            schedule_id={schedule_id}
                                            store_id={store_id}
                                            answerProp={answerProp}
                                            answers={answers}
                                            key={field.label + index}
                                            checkComplete={checkComplete}
                                            saveItemSteps={saveItemSteps}
                                        />
                                    )
                                case 33:
                                    return (
                                        <InputPhotoField
                                            item={field}
                                            hasCamera={false}
                                            hasGalery={true}
                                            form_id={form_id}
                                            schedule_id={schedule_id}
                                            store_id={store_id}
                                            answerProp={answerProp}
                                            answers={answers}
                                            key={field.label + index}
                                            checkComplete={checkComplete}
                                            saveItemSteps={saveItemSteps}
                                        />
                                    )

                                case 7:
                                case 8:
                                case 18:
                                    return (
                                        <SiNoNaField
                                            item={field}
                                            form_id={form_id}
                                            schedule_id={schedule_id}
                                            store_id={store_id}
                                            answerProp={answerProp}
                                            answers={answers}
                                            key={field.label + index}
                                            closeBottomSheet={closeBottomSheet}
                                            checkComplete={checkComplete}
                                            keyboardHiddenState={keyboardHiddenState}
                                            onFocus={onFocus}
                                            activeInputId={activeInputId}
                                            saveItemSteps={saveItemSteps}
                                            onAnswerChange={onFieldAnswered(field)}
                                        />
                                    )
                                case 48:
                                    return (
                                        <PonderateNumberField
                                            // `field` acá es el field "merge" armado en
                                            // SiNoNaItem: junta todos los fields type 48
                                            // originales, uno por secondary_action. Los
                                            // desanidamos para volver a tener la lista plana
                                            // de numeradores/denominadores/resultado.
                                            fields={(
                                                field.secondary_actions ?? []
                                            ).flatMap(
                                                (action) => action.fields ?? [],
                                            )}
                                            form_id={form_id}
                                            schedule_id={schedule_id}
                                            store_id={store_id}
                                            answerProp={answerProp}
                                            answers={answers}
                                            key={field.label + index}
                                            checkComplete={checkComplete}
                                            keyboardHiddenState={keyboardHiddenState}
                                            onFocus={onFocus}
                                            activeInputId={activeInputId}
                                            parentContext={parentContext}
                                        />
                                    )
                                case 49:
                                    return (
                                        <InputDateField
                                            item={field}
                                            form_id={form_id}
                                            schedule_id={schedule_id}
                                            store_id={store_id}
                                            answerProp={answerProp}
                                            key={field.label + index}
                                            closeBottomSheet={closeBottomSheet}
                                            checkComplete={checkComplete}
                                            onSubInputMeasure={onSubInputMeasure}
                                            initialValue={getFieldSavedText(field)}
                                            parentContext={parentContext}
                                        />
                                    )
                                default:
                                    return <Text key={index}>No se pudo cargar</Text>
                            }
                        })()}
                        {incompleteIds?.has(field._id) && (
                            <Text
                                style={{
                                    color: theme.colors.colorDisapproved,
                                    fontSize: 12,
                                    fontWeight: '600',
                                    marginTop: 6,
                                }}
                            >
                                * Este campo es requerido
                            </Text>
                        )}
                    </View>
                )
            })}
        </View>
    )
}
